var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Layout',{attrs:{"mastheadBackgroundImage":_vm.bgImages.masthead}},[_c('template',{slot:"headline"}),_vm._v(" "),_c('template',{slot:"body"},[_c('AboutIntro')],1)],2),_vm._v(" "),_c('FooterCTA')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f974b8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/our-company/index.vue
// module id = null
// module chunks = 